// A meta tag
import Head from 'next/head'

export default ({ content, name }) => {
  return (
    <Head>
      <meta content={content} name={name} />
    </Head>
  )
}